<!-- Divider -->
<div
    class="core-vertical-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
